import { BlockInstanceType } from '../../types/blocks/BlockInterface';
import { ContentType } from '../../types/content/Content';
import { FeatureNameEnum } from 'constants-content';

function isBlockVisible(
  child: any,
  interactionData: Record<string, any>
): boolean {
  const displayIf = child?.displayIf;

  if (!displayIf?._bind) {
    return true;
  }

  // name+source pattern: only evaluate if source is 'data'
  if (!displayIf.op) {
    return displayIf.source !== 'data' || !displayIf.name
      ? true
      : Boolean((interactionData as any)?.[displayIf.name]);
  }

  // op pattern: only evaluate when op references 'data' — props-based conditions
  // can't be evaluated here (no block props available) so we default to visible
  if (!/\bdata\b/.test(displayIf.op)) {
    return true;
  }

  try {
    // eslint-disable-next-line no-new-func
    const fn = new Function(
      'data',
      'props',
      'state',
      'features',
      `"use strict"; return (${displayIf.op});`
    );

    return Boolean(fn(interactionData, {}, null, {}));
  } catch (err) {
    console.error('[getVisibleContentData] failed to evaluate displayIf.op', err);
    return true;
  }
}

/**
 * @deprecated This function has been moved to the `renderers` package. Please use `getVisibleContentData` from `renderers` instead.
 */
export default function getVisibleContentData(
  content?: ContentType | null,
  interactionData?: Record<string, any>
) {
  const result: {
    features: (string | FeatureNameEnum)[];
    data: string[];
  } = {
    features: [],
    data: [],
  };

  if (!content?.block) {
    return undefined;
  }

  const getVisibleFields = (children: BlockInstanceType[]) => {
    children.forEach((child: any) => {
      if (
        interactionData !== undefined &&
        !isBlockVisible(child, interactionData)
      ) {
        return;
      }

      if (child?.children && child?.children.length) {
        // some data fields may be nested so we need to iterate over them too
        getVisibleFields(child?.children);
      } else if (Array.isArray(child?.properties?.children)) {
        getVisibleFields(child.properties.children);
      } else if (child?.properties?.featureKey) {
        result.features.push(child?.properties.featureKey);
      } else if (child?.properties?.propertyKey) {
        result.data.push(child?.properties.propertyKey);
      }
    });
  };

  if (content && Array.isArray(content?.block?.properties?.children)) {
    getVisibleFields(content.block.properties.children);
  }

  return result;
}
